import React, { useEffect } from "react";
import { IGif } from "@/common/services/types";
import { GalleryGif } from "./GalleryGif";
import { useGalleryQuery } from "@/common/queries/queries";

interface IGalleryGifContainerProps {
  galleryId: string;
  initialGif: IGif;
  onSetGalleryGif: (gif: IGif) => void;
  onLike: () => void;
  isVisible: boolean;
  sendGifView: (gif: IGif) => void;
  onSetGalleryImages: (qty: number) => void;
}

export const GalleryGifContainer: React.FC<IGalleryGifContainerProps> = ({
  galleryId,
  onSetGalleryImages,
  ...props
}) => {
  const { data } = useGalleryQuery(galleryId);

  useEffect(() => {
    if (data) {
      onSetGalleryImages(data.gifs.length);
    }
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <GalleryGif gallery={data.gifs} {...props} />
  );
};
